import { z } from 'zod'

export const sandboxPayInSchema = z.object({
  amount: z.number().positive().max(100_000_000),
})

export type SandboxPayInDto = z.infer<typeof sandboxPayInSchema>
